var _rect, _rect2, _rect3, _rect4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSrcPortalIconsBlack06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.64 22.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 15.68,
    width: 4.48,
    height: 6.72
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.72,
    y: 6.72,
    width: 4.48,
    height: 15.68
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.44,
    y: 13.44,
    width: 4.48,
    height: 8.96
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.16,
    width: 4.48,
    height: 22.4
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrcPortalIconsBlack06);
export default __webpack_public_path__ + "static/media/SRC-Portal-Icons-Black-06.16f792f93c078d553b102e942ee5a10a.svg";
export { ForwardRef as ReactComponent };